import React, { useEffect } from 'react';
import Cookies from 'universal-cookie';
import { api2, getCSRFToken } from '../../stores/api';
import { toast } from 'react-toastify';

/**
 * @param {function} onTokenFetched - Optional callback when token is successfully fetched
 * @param {function} onError - Optional callback when token fetch fails
 */
const CSRFComponent = ({ onTokenFetched, onError }) => {
  const cookies = new Cookies();

  /**
   * Check CSRF token exist in cookies, if not fetch them
   */
  const checkAndFetchCSRFToken = async () => {
    const csrfToken = cookies.get('csrf_token');

    if (csrfToken) {
      return;
    }

    await fetchCSRFToken();
  };

  /**
   * Fetch CSRF token from the API
   */
  const fetchCSRFToken = async () => {
    try {
      const response = await getCSRFToken();

      if (response.ok) {
        const csrfToken = cookies.get('csrf_token');

        if (csrfToken) {
          if (onTokenFetched) onTokenFetched({ csrfToken });
        } else {
          toast.error('Failed to fetch CSRF token');
        }
      } else {
        toast.error('Failed to fetch CSRF token');
      }

    } catch (error) {
      const errorMessage = error.message || 'Failed to fetch CSRF token';
      if (onError) onError(errorMessage);
    }
  };

  useEffect(() => {
    checkAndFetchCSRFToken();
  }, []);

  return null;
};

export default CSRFComponent;
